<template>
  <d-card class="check-in-card" :data-testid="$testIds.receptionDesk.checkIn.form">
    <d-card-body class="check-in-card-body">
      <div v-if="!previouslySelectedMemberObject" class="check-in-section check-in-search-section">
        <div class="check-in-section-header">
          <label class="check-in-field-label"> {{ this.$t("checkin.members") }} </label>
          <d-checkbox class="auto-scan-control" v-model="autoScan">
            {{ this.$t("checkin.autoScan") }}
          </d-checkbox>
        </div>
        <div :data-testid="$testIds.receptionDesk.checkIn.memberSearch">
          <dropdown-auto-complete
            :on-enter-search="true && !autoScan"
            :disable-component="disableCodeScanField"
            ref="memberdropdown"
            v-on:input="dropdownInputChanged"
            v-model="memberSelect.selected"
            :value="textVal"
            :is-async="true"
            continer-class="mb-2"
            :clear-text="clearText"
            dropdown-class=""
            :input-class="{
              'form-control': true,
              'verror-input': $v.memberSelect.selected.$invalid && submitClicked,
            }"
            :items="memberSelect.options"
          ></dropdown-auto-complete>
        </div>
        <div class="verror" v-if="!$v.memberSelect.selected.required && submitClicked">
          {{ this.$t("checkin.memberIsRequired") }}
        </div>

        <!--        <d-select id="members-list" v-model="memberSelect.selected" :options="memberSelect.options"/>-->
      </div>
      <template v-if="memberSelect.selected">
        <div
          class="member-more-details"
          :data-testid="$testIds.receptionDesk.checkIn.selectedMember"
        >
          <div class="member-data">
            <!--            <div class="member-attribute">Date of Birth</div>-->
            <!--            <div class="member-attribute-value">-->
            <!--              {{-->
            <!--                selectedMemberData.birthday ? this.$date(selectedMemberData.birthday)-->
            <!--                  .format('YYYY-MM-DD') : 'NA'-->
            <!--              }}-->
            <!--            </div>-->
            <template v-if="$store.state.settings.tenantSetting.enableCardReader">
              <div class="member-attribute">{{ this.$t("checkin.cardNumber") }}</div>
              <div class="member-attribute-value">
                {{
                  selectedMemberData.cardNumber
                    ? selectedMemberData.cardNumber
                    : this.$t("generalMessages.NA")
                }}
              </div>
            </template>
            <div class="member-attribute">{{ this.$t("checkin.idNumber") }}</div>
            <div class="member-attribute-value">
              {{
                selectedMemberData.idNumber
                  ? selectedMemberData.idNumber
                  : this.$t("generalMessages.NA")
              }}
            </div>
            <div class="member-attribute">{{ this.$t("checkin.membershipLatest") }}</div>
            <div class="member-attribute-value">
              <template v-if="selectedMemberLastMembership">
                {{ selectedMemberLastMembership.membershipTypeData.name }}<br />
                {{ formatDate(selectedMemberLastMembership.startingDate) }}
                {{
                  selectedMemberLastMembership.endDate
                    ? " - " + formatDate(selectedMemberLastMembership.endDate)
                    : ""
                }}
              </template>
              <template v-else>
                {{ this.$t("generalMessages.noRecords") }}
              </template>
            </div>
            <div v-if="hasFeature('classes-management')" class="member-attribute">{{ this.$t("member.associatedToClassInCheckIn") }}</div>
            <div v-if="hasFeature('classes-management')" class="member-attribute-value">
              <template v-if="selectedMemberData && selectedMemberData.associatedClassToMember && selectedMemberData.associatedClassToMember.name">
                {{ selectedMemberData.associatedClassToMember.name }}<br />
              </template>
              <template v-else>
                {{ this.$t("generalMessages.noRecords") }}
              </template>
            </div>
            <div class="member-status-badges">
              <d-badge outline pill theme="danger" class="mr-1" v-if="memberStatusData.balance < 0">
                {{ this.$t("checkin.balance") }}: {{ memberStatusData.balance }}
              </d-badge>
              <StatusBadge
                v-if="memberStatusData.isExpiredMembership"
                status="expired"
                :label="$t('checkin.expiredMembership')"
                class="mr-1"
              />
              <StatusBadge
                v-if="
                  !memberStatusData.isExpiredMembership &&
                  memberStatusData.numberofDaysBeforExpiredMembership &&
                  memberStatusData.numberofDaysBeforExpiredMembership <=
                    $store.state.settings.tenantSetting.membershipExpiryThreshold
                "
                status="expiring soon"
                :label="`${$t('checkin.numberofDaysBeforeExpiredMembership')}: ${memberStatusData.numberofDaysBeforExpiredMembership}`"
                class="mr-1"
              />
              <StatusBadge v-if="memberStatusData.isBlacklisted" status="blocked" :label="$t('checkin.blackListed')" class="mr-1" />
              <StatusBadge v-if="memberStatusData.isSuspended" status="suspended" :label="$t('checkin.suspended')" class="mr-1" />
            </div>
          </div>
          <div class="member-image-frame">
            <ProfileImageState :id="`memberAvatar${selectedMemberData.avatarDocumentId}`"
                 :src="(selectedMemberData.avatarDocumentId !== 0
                        && selectedMemberData.avatarDocumentId !== null
                        && selectedMemberData.avatarDocumentId !== ''
                        && getProfileImage(selectedMemberData.avatarDocumentId))
                      || selectedMemberData.avatarDocumentURL" class="member-image"
                 :alt="$fullName(selectedMemberData.givenName, selectedMemberData.middleName, selectedMemberData.familyName)"
                 :name="$fullName(selectedMemberData.givenName, selectedMemberData.middleName, selectedMemberData.familyName)" />
          </div>
        </div>
        <div class="check-in-section check-in-form-section">
        <div class="gate-selection check-in-form-row" v-if="gateSelect.options.length !== 2">
          <label class="member-attribute check-in-field-label" for="gate-select"> {{ this.$t("checkin.gate") }} </label>
          <d-select
            :class="{ 'verror-input': $v.gateSelect.selected.$invalid && submitClicked }"
            id="gate-select"
            :data-testid="$testIds.receptionDesk.checkIn.gate"
            v-model="$v.gateSelect.selected.$model"
            :options="gateSelect.options"
          />

          <div class="verror" v-if="!$v.gateSelect.selected.required && submitClicked">
            {{ this.$t("generalMessages.gateIsRequired") }}
          </div>
        </div>
        <div
          class="membership-selection check-in-form-row"
          v-if="spendableMembershipOptions.length > 1"
        >
          <label class="member-attribute check-in-field-label" for="membership-select">
            {{ this.$t("checkin.membershipToDeduct") }}
          </label>
          <d-select
            id="membership-select"
            :data-testid="$testIds.receptionDesk.checkIn.membership"
            v-model="membershipSelect.selected"
            :options="spendableMembershipOptions"
          />
          <div class="check-in-field-hint">{{ this.$t("checkin.membershipToDeductHint") }}</div>
        </div>
        <div class="time-selection check-in-form-row">
          <label class="member-attribute check-in-field-label"> {{ this.$t("checkin.time") }} </label>
          <!--          <div class="datetime-icon-container"-->
          <!--               @click="()=>{this.$store.commit('changeDatetimeDialogDisplayed',true)}">-->
          <div @click.stop class="datetime-icon-container">
            <datetime
            @click.stop
              type="datetime"
              v-model="datetimeObj"
              :input-class="{
                'form-control': true,
                'verror-input': $v.datetimeObj.$invalid && submitClicked,
              }"
              class="theme-light-blue"
              :format-commenteddddd="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                timeZoneName: 'short',
              }"
              format="yyyy-MM-dd HH:mm"
              :phrases-commenteddddd="{ ok: 'Continue', cancel: 'Exit' }"
              :hour-step="1"
              :minute-step="1"
              :week-start="7"
              use12-hour
              auto
            ></datetime>
            <!--            value-zone="local"-->
            <CalendarIcon class="calendar-icon-control" />
          </div>
          <div class="verror" v-if="!$v.datetimeObj.required && submitClicked">
            {{ this.$t("generalMessages.timeIsRequired") }}
          </div>
        </div>
        <div class="note-container check-in-form-row">
          <label class="member-attribute check-in-field-label" for="note-checkin"> {{ this.$t("checkin.note") }} </label>
          <d-textarea id="note-checkin" v-model="note" />
        </div>
        </div>
        <div class="save-container">
          <d-button
            type="button"
            theme="light"
            class="cancel-button btn-border-gray"
            :data-testid="$testIds.receptionDesk.checkIn.cancel"
            @click="cancelCheckInForm"
          >
            {{ this.$t("generalMessages.cancel") }}
          </d-button>
          <d-button
            type="submit"
            theme="info"
            :data-testid="$testIds.receptionDesk.checkIn.save"
            @click="saveCheckIn($event)"
          >
            {{ this.$t("generalMessages.save") }}
          </d-button>
        </div>
      </template>
    </d-card-body>
  </d-card>
</template>

<script>
import DropdownAutoComplete from '@/components/DropdownAutoComplete';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';

import { required } from 'vuelidate/lib/validators';
import gatesService from '@/services/gates.service';
import { resolveBranchId } from '@/utils/activeBranch';
import membershipsService from '@/services/memberships.service';
import membersService from '@/services/members.service';
import membersLogsService from '@/services/membersLogs.service';
import {
  defaultMembershipToSpend,
  membershipPickerOptions,
} from '@/utils/membershipEntryConsumption';
import { fetchAllPages } from '@/utils/fetchAllPages';
import ProfileImageState from '@/components/ProfileImageState.vue';

export default {
  name: 'CheckIn',
  components: {
    DropdownAutoComplete,
    ProfileImageState,
    datetime: Datetime,
  },
  data() {
    return {
      gateLst: [],
      allMembers: [],
      memberSelect: {
        selected: undefined,
        options: [
          // { value: '', text: 'Select Member', disabled: true },
        ],
      },
      gateSelect: {
        selected: '',
        options: [
          {
            value: '',
            text: this.$t('codeScanner.selectGate'),
            disabled: true,
          },
        ],
      },
      datetimeObj: this.$date().toISOString(), // .toISOString(),
      note: '',
      textVal: '',
      clearText: false,
      memberStatusData: {},
      membershipLst: [],
      membershipSelect: {
        selected: '',
      },
      membershipClassMemberLst: [],
      submitClicked: false,
      autoScan: false,
      disableCodeScanField: false,
    };
  },
  validations: {
    memberSelect: {
      selected: {
        required,
      },
    },
    gateSelect: {
      selected: {
        required,
      },
    },
    datetimeObj: {
      required,
    },
  },
  props: {
    previouslySelectedMemberObject: {
      type: Object,
    },
  },
  created() {
    // this.getAllMembers();
    this.getGates();

    // if you want to select user and disable the search so the check-in will be for specific member
    if (this.previouslySelectedMemberObject) {
      this.allMembers = [this.previouslySelectedMemberObject];
      this.memberSelect.selected = this.previouslySelectedMemberObject.id;
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.memberdropdown) {
        this.$refs.memberdropdown.focusOnInput();
      }
    });
  },
  computed: {
    selectedMemberData() {
      const indexOfMember = this.allMembers.findIndex((m) => m.id === this.memberSelect.selected);
      const memberData = this.allMembers[indexOfMember];
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.datetimeObj = this.$date().toISOString();
      return memberData;
    },
    selectedMemberLastMembership() {
      if (!this.membershipLst || this.membershipLst.length === 0) return undefined;
      const today = this.$date().startOf('day');
      const current = this.membershipLst.find((m) => {
        const start = this.$date(m.startingDate).startOf('day');
        const end = m.endDate ? this.$date(m.endDate).startOf('day') : null;
        return start.isBefore(today) || start.isSame(today)
          ? (!end || end.isAfter(today) || end.isSame(today))
          : false;
      });
      return current || this.membershipLst[0];
    },
    spendableMembershipOptions() {
      return membershipPickerOptions(this.membershipLst, {
        entriesLeftLabel: (count) => this.$tc('checkin.entriesLeft', count, { count }),
        noEntriesLabel: () => this.$t('checkin.noEntriesDeducted'),
        formatDate: this.formatDate,
        at: this.$date().toDate(),
      });
    },
  },
  methods: {
    getProfileImage(id) {
      return this.fetchCachedImage(id, () => this.selectedMemberData
        && this.selectedMemberData.avatarDocumentURL);
    },
    async getGates() {
      this.$store.commit('changeShowLoader', true);
      const branchId = resolveBranchId(this.$store.state.auth);
      await gatesService.list({ BranchId: branchId, perPage: 99999 })
        .then((data) => {
          if (data) {
            this.gateLst = data.data;
          } else {
            this.gateLst = [];
          }
          const findGate = this.gateLst.find(
            (i) => i.id === this.$store.state.auth.userData.psDefaultGate,
          );
          if (!findGate) {
            this.gateSelect.selected = '';
          } else {
            this.gateSelect.selected = findGate.id;
          }

          this.gateSelect.options = [
            ...this.gateSelect.options,
            ...this.gateLst.map((g) => ({
              value: g.id,
              text: g.name,
            })),
          ];
          // if there is only one gate then select that gate and hide the input select from the form
          if (this.gateLst.length === 1) {
            this.gateSelect.selected = this.gateLst[0].id;
            // this.$v.gateSelect.selected.$touch();
          }
        })
        .catch((err) => {
          this.showError(err, this.$t('errors.entities.checkIns'), 'load');
        });
      this.$store.commit('changeShowLoader', false);
    },
    async getAllMembersByName(name) {
      // this.$store.commit('changeShowLoader', true);
      if (!name || name.length <= 0) {
        this.memberSelect.options = [];
        return;
      }
      // const cardNumberQuery = this.$store.state.settings.tenantSetting.enableCardReader ? `&CardNumber=${name}` : '';
      //
      // await this.$axios.get(`${this.$store.state.settings.apiURL}/Members?FullName=${name}${cardNumberQuery}`)

      await membersService.searchByWord(name)
        .then((data) => {
          if (data && data.data) {
            this.allMembers = data.data;
            this.memberSelect.options = data.data.map((m) => ({
              value: m.id,
              text: `${m.givenName ? m.givenName : ''} ${m.middleName ? m.middleName : ''} ${
                m.familyName ? m.familyName : ''
              }`,
            }));
          } else {
            this.memberSelect.options = [];
            this.allMembers = [];
          }
          if (this.memberSelect.options.length === 1) {
            // this.memberSelect.selected = this.memberSelect.options[0].value;
            this.$refs.memberdropdown.setResult(this.memberSelect.options[0]);
          }
        })
        .catch((err) => {
          this.showError(err, this.$t('errors.entities.checkIns'), 'load');
          this.memberSelect.options = [];
        });
      // this.$store.commit('changeShowLoader', false);
    },
    async saveCheckIn(event) {
      if (event) {
        event.preventDefault();
      }
      // validation
      this.submitClicked = true;
      if (this.$v.$invalid) {
        return;
      }

      this.$store.commit('changeShowLoader', true);
      await membersLogsService.create({
        memberId: this.selectedMemberData.id,
        gateId: this.gateSelect.selected,
        note: this.note,
        type: 'in',
        entryTimestamp: this.removeTimezoneFromDateToISOFormatString(this.datetimeObj),
        // Omitted when the member has nothing entry-based to spend; the server then decides alone.
        membershipId: this.membershipSelect.selected || undefined,
      })
        .then((data) => {
          if (data) {
            this.$toast.success(this.$t('checkin.successfullyAdded'));

            const gate = this.gateLst.find((g) => g.id === this.gateSelect.selected);

            this.$emit('add-entrie', {
              fullName: this.previouslySelectedMemberObject && this.previouslySelectedMemberObject.fullName,
              gateName: gate && gate.name,
              note: this.note,
              entryTimestamp: this.removeTimezoneFromDateToISOFormatString(this.datetimeObj),
            });

            this.submitClicked = false;
            this.memberSelect.selected = undefined;
            this.memberSelect.options = [];
            this.allMembers = [];
            this.membershipLst = [];
            this.resetMembershipSelection();
            this.clearText = true;
            this.$emit('update-member-logs');
            this.$nextTick(() => {
              const dropdown = this.$refs.memberdropdown;
              if (!dropdown) return;
              dropdown.setResult({ text: '', value: '' });
              dropdown.focusOnInput();
            });
          }
        })
        .catch(() => {
        });
      this.$store.commit('changeShowLoader', false);
    },
    // Preselect what the server would spend anyway, so leaving the picker alone changes nothing.
    resetMembershipSelection() {
      const chosen = defaultMembershipToSpend(this.membershipLst, this.$date().toDate());
      this.membershipSelect.selected = chosen ? chosen.id : '';
    },
    cancelCheckInForm() {
      this.$emit('close-check-in-form');
    },
    async dropdownInputChanged(input) {
      this.clearText = false;
      if (this.autoScan !== true) {
        await this.getAllMembersByName(input);
      }
      // auto scan
      // this will be used when the scanner scan a member that is not exist will display error message and empty the field
      if (this.autoScan === true) {
        if (input.length >= this.$store.state.settings.tenantSetting.cardNumberMinLength) {
          await this.getAllMembersByName(input);

          if (this.allMembers.length <= 0) {
            // if there is not result then clear the input

            const emptyDropDownValueMember = {
              text: '',
              value: '',
            };
            this.$refs.memberdropdown.setResult(emptyDropDownValueMember);
            this.$toast.error(`${this.$t('checkin.couldNotFindMemberWithScannedCode')} : ${input}`);
          }
        }
      }
    },
    async getMemberStatusData() {
      // this.$store.commit('changeShowLoader', true);

      await membersService.getMemberStatusData(this.selectedMemberData.id)
        .then((data) => {
          if (data) {
            this.memberStatusData = data;
          } else {
            this.memberStatusData = {};
          }
        })
        .catch((err) => {
          this.showError(err, this.$t('errors.entities.checkIns'), 'load');
          this.memberStatusData = {};
        });
      // this.$store.commit('changeShowLoader', false);
    },
    async getMembershipsForSelectedMember() {
      // this.$store.commit('changeShowLoader', true);
      this.membershipLst = [];
      // Every page, not the default first 10 oldest-first: a member with a long history had the
      // very memberships this form is about fall off the end -- both the one shown and the ones
      // offered to deduct from.
      await fetchAllPages(async ({ page, elementPerPage }) => {
        const data = await membershipsService.list({
          MemberId: this.selectedMemberData.id,
          orderBy: 'StartingDate',
          page,
          elementPerPage,
        });

        if (!data || data.status !== true) {
          throw 'Server return status false';
        }

        return { items: data.data, totalCount: data.totalCount };
      })
        .then((memberships) => {
          this.membershipLst = memberships;
          this.resetMembershipSelection();
        })
        .catch((err) => {
          this.showError(err, this.$t('errors.entities.checkIns'), 'load');
        });
      // this.$store.commit('changeShowLoader', false);
    },
    async codeScan() {
      this.disableCodeScanField = true;
      if (this.selectedMemberData) {
        await this.saveCheckIn();
      }
      this.disableCodeScanField = false;
      // setTimeout(() => {
      //   this.$refs.memberdropdown.focusOnInput();
      // }, 100);
    },
  },
  watch: {
    selectedMemberData() {
      if (this.selectedMemberData) {
        this.getMemberStatusData();
        this.getMembershipsForSelectedMember();
        if (this.autoScan === true) {
          this.codeScan();
        }
        // there is a code regardign the auto scan on the input change the method called :dropdownInputChanged this will be used when the scanner scan a member that is not exist will display error message and empty the field
      }
    },
    autoScan(value) {
      if (value === true) {
        this.$refs.memberdropdown.focusOnInput();
      }
    },
    // datetimeObj() {
    //   if (this.$store.state.ui.datetimeDialogDisplayed) {
    //     this.$store.commit('changeDatetimeDialogDisplayed', false);
    //   }
    // },
  },
};
</script>

<style scoped>
.check-in-card {
  overflow: visible;
  border: 1px solid var(--fitnet-dashboard-surface-border, rgba(211, 226, 241, 0.85));
  border-radius: 0.85rem;
  background: var(--fitnet-dashboard-surface-bg, linear-gradient(180deg, #ffffff 0%, #f8fbff 100%));
  box-shadow: 0 0.85rem 1.85rem rgba(24, 59, 99, 0.08);
}

.check-in-card-body {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  overflow: visible;
  padding: 1rem;
}

.check-in-section,
.member-more-details {
  border: 1px solid rgba(211, 226, 241, 0.78);
  border-radius: 0.75rem;
  background: rgba(255, 255, 255, 0.88);
}

.check-in-section {
  padding: 0.9rem;
}

.check-in-search-section {
  position: relative;
  z-index: 2;
  overflow: visible;
}

.check-in-search-section >>> .mb-2 {
  margin-bottom: 0 !important;
}

.check-in-search-section >>> .autocomplete {
  width: 100%;
}

.check-in-search-section >>> .dropdown-menu,
.check-in-search-section >>> .autocomplete-results {
  top: calc(100% + 0.3rem);
  right: 0;
  left: 0;
  z-index: 1090;
}

.check-in-search-section >>> input.form-control {
  width: 100%;
  height: 2.75rem;
  padding: 0.58rem 0.85rem;
  line-height: 1.45;
  box-sizing: border-box;
}

.check-in-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.55rem;
}

.check-in-field-label,
.member-attribute {
  margin-bottom: 0.35rem;
  color: var(--fitnet-muted-text-color, #6f849d);
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1.3;
}

.check-in-field-hint {
  margin-top: 0.3rem;
  color: var(--fitnet-muted-text-color, #6f849d);
  font-size: 0.72rem;
  line-height: 1.35;
}

.auto-scan-control {
  position: relative;
  display: inline-flex;
  align-items: center;
  min-height: 2rem;
  margin: 0;
  padding: 0.35rem 0.65rem 0.35rem 2.05rem;
  border: 1px solid rgba(211, 226, 241, 0.78);
  border-radius: 0.55rem;
  background: rgba(247, 251, 255, 0.92);
  color: var(--fitnet-text-color, #31506f);
  font-size: 0.82rem;
  font-weight: 500;
  white-space: nowrap;
}

.auto-scan-control >>> .custom-control-label {
  display: inline-flex;
  align-items: center;
  min-height: 1.25rem;
  margin: 0;
  padding: 0;
  line-height: 1.25;
}

.auto-scan-control >>> .custom-control-input,
.auto-scan-control >>> .custom-control-label::before,
.auto-scan-control >>> .custom-control-label::after {
  top: 50%;
  left: 0.65rem;
  transform: translateY(-50%);
}

[dir="rtl"] .auto-scan-control {
  padding: 0.35rem 2.05rem 0.35rem 0.65rem;
}

[dir="rtl"] .auto-scan-control >>> .custom-control-label {
  padding: 0;
}

[dir="rtl"] .auto-scan-control >>> .custom-control-input,
[dir="rtl"] .auto-scan-control >>> .custom-control-label::before,
[dir="rtl"] .auto-scan-control >>> .custom-control-label::after {
  right: 0.65rem;
  left: auto;
}

.member-more-details {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(248, 251, 255, 0.92) 100%);
}

.member-data {
  flex: 1;
  min-width: 0;
}

.member-attribute-value {
  margin-bottom: 0.75rem;
  color: var(--fitnet-heading-color, #274967);
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.member-status-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-top: 0.2rem;
}

.member-image-frame {
  flex: 0 0 auto;
  align-self: flex-start;
  padding: 0.4rem;
  border: 1px solid rgba(169, 209, 235, 0.72);
  border-radius: 0.8rem;
  background: rgba(247, 251, 255, 0.95);
  box-shadow: 0 0.45rem 0.95rem rgba(24, 59, 99, 0.07);
}

.member-more-details .member-image {
  display: block;
  font-size: 8.5rem;
  width: 8.5rem;
  height: 8.5rem;
  object-fit: cover;
  border-radius: 0.6rem;
}

.check-in-form-section {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.check-in-form-row {
  display: grid;
  grid-template-columns: 6.5rem minmax(0, 1fr);
  gap: 0.75rem;
  align-items: start;
}

.check-in-form-row .verror {
  grid-column: 2;
  margin-top: -0.45rem;
}

.note-container textarea {
  min-height: 5.25rem;
  resize: vertical;
}

.datetime-icon-container {
  display: flex;
  align-items: center;
  gap: 0.45rem;
}

.datetime-icon-container .vdatetime {
  flex: 1;
  min-width: 0;
}

.datetime-icon-container .img-icon {
  width: 2.25rem;
  height: 2.25rem;
  padding: 0.45rem;
  border: 1px solid rgba(169, 209, 235, 0.65);
  border-radius: 0.55rem;
  background: rgba(247, 251, 255, 0.92);
  opacity: 0.82;
}

.save-container {
  display: flex;
  justify-content: flex-end;
  gap: 0.55rem;
  padding-top: 0.15rem;
}

.save-container .btn {
  min-width: 5.75rem;
  font-weight: 600;
}

.cancel-button {
  color: var(--fitnet-text-color, #31506f);
  background: #fff;
  border-color: rgba(211, 226, 241, 0.95);
}

.check-in-card >>> .form-control,
.check-in-card >>> select,
.check-in-card >>> textarea {
  border-color: rgba(211, 226, 241, 0.95);
  border-radius: 0.55rem;
  color: var(--fitnet-text-color, #31506f);
  box-shadow: none;
}

.check-in-card >>> .form-control:focus,
.check-in-card >>> select:focus,
.check-in-card >>> textarea:focus {
  border-color: rgba(35, 136, 199, 0.45);
  box-shadow: 0 0 0 0.16rem rgba(35, 136, 199, 0.12);
}

[dir="rtl"] .save-container {
  justify-content: flex-start;
}

@media screen and (max-width: 575px) {
  .check-in-section-header,
  .member-more-details {
    flex-direction: column;
    align-items: stretch;
  }

  .member-image-frame {
    align-self: center;
  }

  .check-in-form-row {
    grid-template-columns: 1fr;
  }

  .check-in-form-row .verror {
    grid-column: 1;
    margin-top: -0.35rem;
  }

  .save-container {
    justify-content: stretch;
  }

  .save-container .btn {
    flex: 1;
  }
}
</style>
